import { Menu, Search } from 'lucide-react';
import { UserMenu } from './UserMenu';
import { HatirlatmaBanner } from '@features/hatirlatma';
import { AiRehberiButton } from '@features/rehber';

interface HeaderProps {
  onMobileMenuClick?: () => void;
  onSearchOpen?: () => void;
}

export function Header({ onMobileMenuClick, onSearchOpen }: HeaderProps = {}) {
  return (
    <header className="flex h-16 items-center justify-between border-b bg-card px-4 md:px-6">
      <div className="flex flex-1 items-center gap-2 md:gap-4">
        {/* Mobil hamburger — desktop'ta gizli */}
        <button
          type="button"
          onClick={onMobileMenuClick}
          className="-ml-1 rounded-md p-2 text-muted-foreground hover:bg-muted md:hidden"
          aria-label="Menüyü aç"
        >
          <Menu className="h-5 w-5" />
        </button>
        <button
          type="button"
          onClick={onSearchOpen}
          className="relative flex h-10 w-full max-w-md items-center rounded-md border border-input bg-background px-3 text-left text-sm text-muted-foreground hover:bg-muted"
          aria-label="Arama aç"
        >
          <Search className="mr-2 h-4 w-4" />
          <span className="flex-1">Ara...</span>
          <kbd className="ml-2 hidden rounded border bg-muted px-1.5 py-0.5 text-xs sm:inline-block">
            Ctrl+K
          </kbd>
        </button>
      </div>
      <div className="flex items-center gap-2">
        <AiRehberiButton />
        <HatirlatmaBanner />
        <UserMenu />
      </div>
    </header>
  );
}
